import { render, staticRenderFns } from "./cardetail.vue?vue&type=template&id=94242924&"
import script from "./cardetail.vue?vue&type=script&lang=js&"
export * from "./cardetail.vue?vue&type=script&lang=js&"
import style0 from "./cardetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports